export const searchTermFromURL = (): string | undefined => {
  if (typeof window === "undefined") return

  if (window.location.pathname.endsWith("/shop/search") === false) return

  return new URL(window.location.href).searchParams.get("term") ?? undefined
}
